import { IIcon } from '~/components/ui/Icon'

export default function InformationOutline({ size, color }: Pick<IIcon, 'size' | 'color'>) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24'>
      {/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}
      <path
        fill={color}
        d='M12 17.75a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75M12 7a1 1 0 1 1 0 2a1 1 0 0 1 0-2'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12S17.937 22.75 12 22.75S1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5a9.25 9.25 0 0 0 0-18.5'
        clipRule='evenodd'
      />
    </svg>
  )
}
